<ng-template #content let-c="close" let-d="dismiss">
    <!--<div class="modal-header border-0">
        <h4 class="modal-title text-center" >
            Use of Scout - Important Instructions
        </h4>
    </div>-->
    <div class="modal-body">
        <h4 class="text-left consent-title">
            Use of Scout - Important Instructions
        </h4>
        <p>
            Welcome, we are pleased to encourage the use of Scout for professional and work-related purposes.
            It is intended for internal use only.
        </p>
        <ul class="bullet-points">
            <li class="mb-3">
                This AI tool is designed to provide a safe and protected environment for you. However, the use of Scout does not guarantee the accuracy of the AI-generated information. We urge you to check the
                information for any mistakes.
            </li>
            <li class="mb-3">
                Scout must be used in strict accordance with Genpact's policies, including the 
                <a target="_blank" href="https://genpactonline.sharepoint.com/sites/Legal/Compliance/Pages/Policy-Central.aspx" class="link">Code of Conduct</a>
            </li>
            <li class="mb-3">
                Please avoid disclosing client-related information which may be subject to client's authorization and
                legal terms, as well as any personal and sensitive information.
            </li>
        </ul>
        <p>For more detailed information, please refer to the <a target="_blank" [href]="termsLink" tabindex="3"> Terms of Use</a></p>
        <form [formGroup]="form">
            <div class="form-check">
                <input class="form-check-input" type="checkbox" id="agreeCheckbox" tabindex="1" formControlName="agree" ngbAutofocus>
                <label class="form-check-label" for="agreeCheckbox">
                    I understand and acknowledge the above terms and commit to compliance with the standards set forth
                    by Genpact's policies.
                </label>
            </div>
            <div class="d-flex justify-content-center">
                <button class="btn btn-primary-light mt-3 btn-md fw-500" (click)="proceed()" [disabled]="!form.get('agree')?.value">
                    Proceed
                </button>
            </div>
        </form>
    </div>
</ng-template>